<div class="row animated fadeIn">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Reporte de Deuda por Grado</h4>
        <h6 class="card-subtitle">Comparativa entre deuda del mes actual y el mismo mes del año anterior.</h6>

        <!-- Barra de Filtros usando MesanioComponent y Filtro de Grado -->
        <div class="filter-toolbar mt-3">
          <div class="row align-items-center">
            
            <!-- Selector de Grado -->
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Grado</mat-label>
                <mat-select [(ngModel)]="gradoSeleccionado" (selectionChange)="aplicarFiltroGrado()">
                  <mat-option value="TODOS">-- Todos los grados --</mat-option>
                  <mat-option *ngFor="let g of grados" [value]="g.id">
                    {{ g.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Control de Mes y Año (MesanioComponent) -->
            <div class="col-12 col-md-8">
              <app-mesanio 
                (selectedChange)="onPeriodoSeleccionado($event)">
              </app-mesanio>
            </div>

          </div>
        </div>

        <!-- Spinner de carga -->
        <div *ngIf="cargando" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando datos...</span>
          </div>
          <p class="mt-2 text-muted">Consultando información de deudas...</p>
        </div>

        <!-- Mensaje de Sin Datos -->
        <div *ngIf="!cargando && sinDatos" class="alert alert-info text-center mt-3" role="alert">
          <mat-icon class="align-middle mr-1">info</mat-icon>
          No se encontraron registros de deudas para el periodo o grado seleccionado.
        </div>

        <!-- Contenedor del Gráfico -->
        <div class="chart-container mt-3" [hidden]="cargando || sinDatos">
          <canvas #deudasChart></canvas>
        </div>

      </div>
    </div>
  </div>
</div>
